import { ReactNode } from 'react';

type HandlerFunction = () => void;

class LayoutHandlerService {
	private exportHandler: HandlerFunction | null = null;
	private goBackHandler: HandlerFunction | null = null;
	private pageTitleNode: ReactNode = null;
	private broadcastHandler: HandlerFunction | null = null;

	setExportHandler(handler: HandlerFunction | null) {
		this.exportHandler = handler;
	}

	getExportHandler(): HandlerFunction | null {
		return this.exportHandler;
	}

	setGoBackHandler(handler: HandlerFunction | null) {
		this.goBackHandler = handler;
	}

	getGoBackHandler(): HandlerFunction | null {
		return this.goBackHandler;
	}

	setPageTitleNode(node: ReactNode) {
		this.pageTitleNode = node;
	}

	getPageTitleNode(): ReactNode {
		return this.pageTitleNode;
	}

	setBroadcastHandler(handler: HandlerFunction | null) {
		this.broadcastHandler = handler;
	}

	getBroadcastHandler(): HandlerFunction | null {
		return this.broadcastHandler;
	}
}

export const layoutHandlerService = new LayoutHandlerService();
